/*************************************************/
/* MAP                                           */
/*************************************************/

export function map() {

    const mapContainer = document.querySelector('.map__map-image'); // Adjust selector accordingly

    if (!mapContainer) {
        // Exit the function if the map component is not present
        return;
    }

    const mapMarkers = document.querySelectorAll('.map__map-marker');
    const markerInfoSelector = '.map__map-marker-info';
    const showClass = 'show';
    const dataAdjusted = 'data-adjusted';
    const dataAdjustedVertical = 'data-adjusted-vertical';
    const screenWidth = window.innerWidth; // Get the screen width
    let markerPaddingPercentage;

    // Set markerPaddingPercentage based on screen width
    if (screenWidth <= 768) {
        markerPaddingPercentage = 3; // Set a larger value for smaller screens
    } else {
        markerPaddingPercentage = 1; // Set a smaller value for larger screens
    }

    // Keep track of original marker positions, markers that have been moved, and their direction
    const originalPositions = {};
    const movedMarkers = new Set();
    const markerDirections = {};

    mapMarkers.forEach(marker => {
        originalPositions[marker.id] = {
            left: marker.style.left,
            top: marker.style.top
        };

        markerDirections[marker.id] = { x: 0, y: 0 }; // Initialize direction as 0 for both x and y

        marker.addEventListener('mouseover', event => {
            const hoveredMarker = event.target;
            const markerInfo = hoveredMarker.nextElementSibling;

            // if (!movedMarkers.size) {
            //     const containerRect = mapContainer.getBoundingClientRect();
            //     const containerWidth = containerRect.width;
            //     const containerHeight = containerRect.height;

            //     const markerRect = hoveredMarker.getBoundingClientRect();
            //     const markerX = (markerRect.left + markerRect.width / 2) / containerWidth * 100;
            //     const markerY = (markerRect.top + markerRect.height / 2) / containerHeight * 100;

            //     let separationNeeded = false;
            //     // Code to make the markers seperate
            //     mapMarkers.forEach(otherMarker => {
            //         if (otherMarker !== hoveredMarker) {
            //             const otherMarkerRect = otherMarker.getBoundingClientRect();
            //             const otherMarkerX = (otherMarkerRect.left + otherMarkerRect.width / 2) / containerWidth * 100;
            //             const otherMarkerY = (otherMarkerRect.top + otherMarkerRect.height / 2) / containerHeight * 100;

            //             const distanceX = Math.abs(markerX - otherMarkerX);
            //             const distanceY = Math.abs(markerY - otherMarkerY);

            //             if (distanceX < markerPaddingPercentage || distanceY < markerPaddingPercentage) {
            //                 separationNeeded = true;

            //                 const directionX = markerX < otherMarkerX ? 1 : -1;
            //                 const directionY = markerY < otherMarkerY ? 1 : -1;
            //                 markerDirections[otherMarker.id] = { x: directionX, y: directionY };

            //                 const offsetX = directionX * markerPaddingPercentage;
            //                 const offsetY = directionY * markerPaddingPercentage;

            //                 otherMarker.style.left = `${parseFloat(otherMarker.style.left) + offsetX}%`;
            //                 otherMarker.style.top = `${parseFloat(otherMarker.style.top) + offsetY}%`;

            //                 movedMarkers.add(otherMarker.id);
            //             }
            //         }
            //     });

            //     if (!separationNeeded) {
            //         hoveredMarker.classList.add(showClass);
            //     }
            // } else {
            // }
            hoveredMarker.classList.add(showClass);

            toggleMarkerInfo(hoveredMarker, markerInfo);

            event.stopPropagation();
        });

        function toggleMarkerInfo(marker, info) {
            document.querySelectorAll(markerInfoSelector).forEach(otherInfo => {
                if (otherInfo === info) {
                    otherInfo.classList.toggle(showClass);

                    if (otherInfo.classList.contains(showClass)) {
                        if (movedMarkers.has(marker.id) && !otherInfo.hasAttribute(dataAdjusted)) {
                            // Determine direction of the marker and adjust info box position
                            const direction = markerDirections[marker.id];
                            const adjustmentX = direction.x * markerPaddingPercentage;
                            const adjustmentY = direction.y * markerPaddingPercentage;

                            const currentLeft = parseFloat(otherInfo.style.left) || 0;
                            const newLeft = currentLeft + adjustmentX;

                            otherInfo.style.left = `${newLeft}%`;
                            otherInfo.setAttribute(dataAdjusted, 'true');

                            if (!otherInfo.hasAttribute(dataAdjustedVertical)) {
                                const currentTop = parseFloat(otherInfo.style.top) || 0;
                                const newTop = currentTop + adjustmentY;

                                otherInfo.style.top = `${newTop}%`;
                                otherInfo.setAttribute(dataAdjustedVertical, 'true');
                            }
                        }
                    }
                } else {
                    otherInfo.classList.remove(showClass);
                }
            });
        }

    });

    // Reset all marker positions and states when clicking anywhere on the map
    mapContainer.addEventListener('click', () => {
        mapMarkers.forEach(marker => {
            marker.style.left = originalPositions[marker.id].left;
            marker.style.top = originalPositions[marker.id].top;
            marker.classList.remove(showClass); // Remove 'show' class from all markers
            markerDirections[marker.id] = { x: 0, y: 0 }; // Reset direction for both x and y

            const markerInfo = marker.nextElementSibling;
            if (markerInfo) {
                if (markerInfo.hasAttribute(dataAdjusted)) {
                    markerInfo.style.left = originalPositions[marker.id].left; // Reset to original left position
                    markerInfo.removeAttribute(dataAdjusted);
                }

                if (markerInfo.hasAttribute(dataAdjustedVertical)) {
                    markerInfo.style.top = originalPositions[marker.id].top; // Reset to original top position
                    markerInfo.removeAttribute(dataAdjustedVertical);
                }
            }
        });

        movedMarkers.clear();

        // Hide marker info boxes
        document.querySelectorAll(markerInfoSelector).forEach(info => {
            info.classList.remove(showClass);
        });
    });
}

